module.exports = "/_next/static/images/ve-46affed86eb4ac31248fe6237a54a604.svg";